import { Link } from 'react-router-dom';
import { ModuleLanding, ModuleOffers, Faq, SectionHead } from '../../shared/components/Common';
import Icon from '../../shared/components/Icons';
import { addDaysIso, img } from '../../shared/data/common';
import { popularDestinations } from './data';
import { hotelQueryString, parseHotelQuery } from './searchModel';

const perks = [
  ['hotels', 'Live prices', 'Rooms and rates checked with the hotel in real time'],
  ['check', 'Free cancellation', 'Filter for rates you can cancel for free'],
  ['wallet', 'All-inclusive totals', 'Taxes and fees included in every price shown'],
  ['headset', '24x7 support', 'Help before, during and after your stay'],
];

const faqs = [
  ['Are the prices per night or for the whole stay?', 'Results show the total for all rooms and nights, including taxes and fees, with the per-night price below it.'],
  ['Why do you ask for a PAN?', 'Indian tax rules require a PAN for every guest on most hotel bookings in India. For children, enter a parent’s PAN. Guests of other nationalities usually give a passport number instead.'],
  ['Can I cancel my booking?', 'Yes, from My Trips. Each room shows its own cancellation rules — many are free to cancel until a few days before check-in. The convenience fee is not refunded.'],
  ['What is the check-in and check-out time?', 'Check-in and check-out times are shown on each hotel page and on your voucher. Most hotels allow check-in from 2:00 PM.'],
  ['Will I pay anything at the hotel?', 'The room price is paid online. Some hotels charge local fees or a refundable deposit at check-in; these are listed on the hotel page under “Fees payable at the hotel”.'],
];

/** Results link for a popular destination, a week ahead for two nights. */
const destinationLink = (name) => `/hotels/results?${hotelQueryString(parseHotelQuery({ name, checkin: addDaysIso(7), checkout: addDaysIso(9), rooms: '2' }))}`;

export default function HotelSearch() {
  return (
    <ModuleLanding tab="hotels" title="Hotels, resorts & homestays" subtitle="Live prices from thousands of hotels in India & abroad · Free cancellation on many rooms · Taxes included" image={img('1566073771259-6a8506099945', 1800)}>
      <section className="section container">
        <div className="perk-row">
          {perks.map(([ic, t, d]) => (
            <div key={t} className="perk"><span className="perk-icon"><Icon name={ic} size={22} /></span><div><b>{t}</b><span className="muted small">{d}</span></div></div>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Popular destinations" />
        <div className="city-chips">
          {popularDestinations.map(([name, sub]) => (
            <Link key={name} to={destinationLink(name)} className="city-chip">
              <Icon name="pin" size={16} /><span><b>{name}</b><small>{sub}</small></span>
            </Link>
          ))}
        </div>
      </section>

      <section className="section container">
        <SectionHead title="Hotel offers" sub="Exclusive deals for Trawtel customers" />
        <ModuleOffers module="hotels" />
      </section>

      <section className="section container">
        <SectionHead title="Frequently asked questions" />
        <Faq items={faqs} />
      </section>
    </ModuleLanding>
  );
}
